<agpr-take-over-panel
    class="agpr-quotaUsageDashboard"
    [fullWidth]="true"
    [fullHeight]="true"
    [coverNav]="coverNav"
    [showTopPadding]="false"
    [showFooter]="false"
    [focusCloseButton]="false"
    [overlayContainer]="overlayContainer"
    [animationTrigger]="animationTrigger"
    [hideSlideOverlay]="hideSlideOverlay"
    (visibleChange)="handleVisibleChange($event)"
>
    <div class="agpr-quotaUsageDashboard-wrapper">
        <div class="agpr-quotaUsageDashboard-header">
            <agpr-button
                [id]="id + '_toggleButton'"
                class="agpr-quotaUsageDashboard-toggleButton"
                [style]="buttonTypes.icon"
                icon="fa-solid fa-angles-right"
                tooltip="Monitoring.mentionSavingUsageDashboard.toggleButton.tooltip"
                (click)="close()"
            ></agpr-button>
            <h2 class="agpr-quotaUsageDashboard-headerLabel">
                {{ 'Monitoring.mentionSavingUsageDashboard' | localize }}
            </h2>
            <span
                class="agpr-quotaUsageDashboard-purchaseBanner"
                [innerHTML]="'Monitoring.mentionSavingUsageDashboard.purchaseBanner' | localize"
            ></span>
        </div>
        <div class="agpr-quotaUsageDashboard-content">
            <div class="agpr-quotaUsageDashboard-contentWrapper">
                <div class="agpr-quotaUsageDashboard-lhp">
                    <div
                        class="agpr-quotaUsageDashboard-gaugeChart"
                        [agprLoading]="dailyAverageUsageLoading"
                    >
                        <agpr-chart [chart]="dailyAverageUsageChart"></agpr-chart>
                    </div>
                    <div class="agpr-quotaUsageDashboard-statField">
                        <label class="agpr-quotaUsageDashboard-statFieldLabel">
                            {{ 'Monitoring.mentionSavingUsageDashboard.totalQuota' | localize }}
                        </label>
                        <span class="agpr-quotaUsageDashboard-statFieldValue">
                            {{ totalQuota }}
                        </span>
                    </div>
                    <div class="agpr-quotaUsageDashboard-statField">
                        <label class="agpr-quotaUsageDashboard-statFieldLabel">
                            {{ 'Monitoring.mentionSavingUsageDashboard.totalQuotaUsed' | localize }}
                        </label>
                        <span class="agpr-quotaUsageDashboard-statFieldValue">
                            {{ totalQuotaUsed }}
                        </span>
                    </div>
                    <div class="agpr-quotaUsageDashboard-statField">
                        <label class="agpr-quotaUsageDashboard-statFieldLabel">
                            {{ 'Monitoring.mentionSavingUsageDashboard.percentOfQuotaUsed' | localize }}
                        </label>
                        <span class="agpr-quotaUsageDashboard-statFieldValue">
                            {{ percentOfQuotaUsed }}
                        </span>
                    </div>
                    <div class="agpr-quotaUsageDashboard-statField">
                        <label class="agpr-quotaUsageDashboard-statFieldLabel">
                            {{ 'Monitoring.mentionSavingUsageDashboard.daysRemaining' | localize }}
                        </label>
                        <span class="agpr-quotaUsageDashboard-statFieldValue">
                            {{ daysRemaining }}
                        </span>
                    </div>
                    <div class="agpr-quotaUsageDashboard-statField">
                        <label class="agpr-quotaUsageDashboard-statFieldLabel">
                            {{ 'Monitoring.mentionSavingUsageDashboard.quotaResetDate' | localize }}
                        </label>
                        <span class="agpr-quotaUsageDashboard-statFieldValue agpr-quotaUsageDashboard-statFieldDateValue">
                            {{ quotaResetDate }}
                        </span>
                    </div>
                </div>
                <div class="agpr-quotaUsageDashboard-lineChart">
                    <h2 class="agpr-quotaUsageDashboard-lineChartHeader">
                        {{ 'Monitoring.mentionSavingUsageDashboard.quotaUsageOverTime' | localize }}
                    </h2>
                    <div
                        class="agpr-quotaUsageDashboard-lineChartWrapper"
                        [agprLoading]="quotaUsageOverTimeLoading"
                    >
                        <agpr-chart [chart]="quotaUsageOverTimeChart"></agpr-chart>
                    </div>
                </div>
            </div>
        </div>
    </div>
</agpr-take-over-panel>

